import React, { useState, useEffect } from 'react';

const BlogTab = () => {
    const [blogs, setBlogs] = useState([]);
    const [form, setForm] = useState({ title: '', category: '', date_published: '', excerpt: '', full_content: '' });
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        const res = await fetch('/api/blogs');
        const data = await res.json();
        setBlogs(data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = new FormData();
        Object.keys(form).forEach(key => data.append(key, form[key]));
        if (image) data.append('image', image);

        const res = await fetch('/api/blogs', {
            method: 'POST',
            body: data
        });
        if (res.ok) {
            fetchBlogs();
            setForm({ title: '', category: '', date_published: '', excerpt: '', full_content: '' });
            setImage(null);
        }
        setLoading(false);
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this blog?")) return;
        await fetch(`/api/blogs/${id}`, { method: 'DELETE' });
        fetchBlogs();
    };

    return (
        <div className="space-y-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                <h3 className="text-lg font-black text-slate-800 uppercase mb-4">Add New Blog</h3>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <label className="text-xs font-bold text-slate-400">Title</label>
                        <input required value={form.title} onChange={e => setForm({...form, title: e.target.value})} className="w-full p-2 border rounded font-bold" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400">Category</label>
                        <input required value={form.category} onChange={e => setForm({...form, category: e.target.value})} className="w-full p-2 border rounded" placeholder="e.g. Technology" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400">Date</label>
                        <input required value={form.date_published} onChange={e => setForm({...form, date_published: e.target.value})} className="w-full p-2 border rounded" placeholder="e.g. Dec 24, 2025" />
                    </div>
                    <div className="col-span-2">
                        <label className="text-xs font-bold text-slate-400">Excerpt (Short Description)</label>
                        <textarea required value={form.excerpt} onChange={e => setForm({...form, excerpt: e.target.value})} className="w-full p-2 border rounded h-20" />
                    </div>
                    <div className="col-span-2">
                        <label className="text-xs font-bold text-slate-400">Full Content</label>
                        <textarea required value={form.full_content} onChange={e => setForm({...form, full_content: e.target.value})} className="w-full p-2 border rounded h-32" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400">Cover Image</label>
                        <input type="file" accept="image/*" onChange={e => setImage(e.target.files[0])} className="w-full text-xs" />
                    </div>
                    <div className="flex items-end">
                        <button type="submit" disabled={loading} className="bg-orange-500 text-white w-full py-2 rounded font-bold uppercase hover:bg-orange-600">
                            {loading ? 'Publishing...' : 'Publish Blog'}
                        </button>
                    </div>
                </form>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {blogs.map(blog => (
                    <div key={blog.id} className="bg-white border rounded-xl overflow-hidden relative group">
                        <img src={`${blog.image_path}`} alt={blog.title} className="w-full h-40 object-cover" />
                        <button onClick={() => handleDelete(blog.id)} className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">×</button>
                        <div className="p-4">
                            <span className="text-xs font-bold text-orange-500">{blog.category}</span>
                            <h4 className="font-bold text-slate-800 line-clamp-1">{blog.title}</h4>
                            <p className="text-xs text-slate-500 mt-1 line-clamp-2">{blog.excerpt}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogTab;